import { combineReducers } from '@reduxjs/toolkit';

import tenantVpaMappingSlice from '../features/tenant_vpa_mapping/TenantVpaSlice'


const rootReducer = combineReducers({
  tenant_vpa_mapping : tenantVpaMappingSlice,
  
});

export default rootReducer;
